import NeatolabsLogo from "@/components/Logo/NeatolabsLogo";
import BossLaserLogo from "@/components/Logo/BossLaserLogo";
import store from "@/store";
import {useSnapshot} from "valtio";


const LogoComponent = () => {
    const {currentUser} = useSnapshot(store)
    const logoAlt = currentUser?.selectedCompany?.store_name === "BossLaser"

    return (
        <>
            {logoAlt ? <BossLaserLogo  height={30} /> : <NeatolabsLogo width={131} height={16} />}
        </>
    )
}

export default LogoComponent
